import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from '../styles/admin/loginStyles';

import { endpoints } from '../api/endpoints';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [status, setStatus] = useState(''); // '', 'loading', 'success', 'error'
    const [message, setMessage] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus('loading');
        setMessage('');

        try {
            console.log('[ForgotPassword] Sending request for email:', email);
            const response = await fetch(endpoints.ForgotPassword, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email }),
            });

            console.log('[ForgotPassword] Response status:', response.status);
            const data = await response.json();
            console.log('[ForgotPassword] Response data:', data);

            if (response.ok) {
                setStatus('success');
                setMessage(data.message || 'Password reset email sent! Please check your inbox.');
                setEmail('');
            } else {
                setStatus('error');
                setMessage(data.message || 'Failed to send reset email. Please try again.');
            }
        } catch (error) {
            console.error('[ForgotPassword] Error:', error);
            setStatus('error');
            setMessage(`Error: ${error.message}. Please check the console for details.`);
        }
    };

    return (
        <div style={styles.wrapper}>
            <div style={styles.form}>
                <h2 style={styles.heading}>Forgot Password</h2>
                <p style={{ textAlign: 'center', color: '#666', marginBottom: '20px' }}>
                    Enter your email address and we'll send you a link to reset your password.
                </p>

                {status === 'success' && (
                    <div style={{ ...styles.successMessage, marginBottom: '20px' }}>
                        {message}
                    </div>
                )}

                {status === 'error' && (
                    <div style={{ ...styles.errorMessage, marginBottom: '20px' }}>
                        {message}
                    </div>
                )}

                <form onSubmit={handleSubmit}>
                    <div style={styles.inputGroup}>
                        <label style={styles.label}>Email Address</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            style={styles.input}
                            placeholder="Enter your email"
                            required
                            disabled={status === 'loading'}
                        />
                    </div>

                    <button
                        type="submit"
                        style={{
                            ...styles.submitBtn,
                            opacity: status === 'loading' ? 0.6 : 1,
                            cursor: status === 'loading' ? 'not-allowed' : 'pointer',
                        }}
                        disabled={status === 'loading'}
                    >
                        {status === 'loading' ? 'Sending...' : 'Send Reset Link'}
                    </button>
                </form>

                <div style={{ marginTop: '20px', textAlign: 'center' }}>
                    <Link to="/login" style={styles.link}>
                        Back to Login
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
